import React from "react";
import { useTranslation } from "react-i18next";

function TestimonialsSection() {
    const { t } = useTranslation();
    const googleReviewUrl = "https://search.google.com/local/writereview?placeid=ChIJW2RnJyht2jERPqizN1gz8EY";
    const testimonials = [
        { quote: t("t1Quote"), name: t("t1Name"), role: t("t1Role") },
        { quote: t("t2Quote"), name: t("t2Name"), role: t("t2Role") },
        { quote: t("t3Quote"), name: t("t3Name"), role: t("t3Role") },
    ];
    return (
        <section className="landing-section landing-section-soft">
            <div className="container">
                <div>
                    <div className="landing-eyebrow">{t("testimonialsEyebrow")}</div>
                    <h2 className="landing-heading">{t("testimonialsTitle")}</h2>
                </div>
                <div className="landing-testi-grid">
                    {testimonials.map(testimonial => (
                        <div className="landing-testi-card" key={testimonial.name}>
                            <p className="landing-testi-quote">{testimonial.quote}</p>
                            <div className="landing-testi-name">{testimonial.name}</div>
                            <div className="landing-testi-role">{testimonial.role}</div>
                        </div>
                    ))}
                </div>
                <div className="landing-google">
                    <div className="landing-google-rating">
                        <span className="landing-google-score">{t("googleScore")}</span>
                        <span className="landing-google-meta">{t("googleMeta")}</span>
                    </div>
                    <a className="landing-google-link" href={googleReviewUrl} target="_blank" rel="noreferrer">{t("reviewUs")} →</a>
                </div>
            </div>
        </section>
    );
}
export default TestimonialsSection;